import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vacancies_list" }
const _hoisted_2 = { class: "flex itemscenter justify-between mt-6" }
const _hoisted_3 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_vacancy_form = _resolveComponent("create-vacancy-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_vacancy_list_item = _resolveComponent("vacancy-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_add_mode)
      ? (_openBlock(), _createBlock(_component_create_vacancy_form, {
          key: 0,
          class: "mt-6",
          loading: _ctx.state.is_add_loading,
          onSubmit: _ctx.createVacancy,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.is_add_mode = false))
        }, null, 8, ["loading", "onSubmit"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_page_title, { title: "Вакансии" }),
            _createVNode(_component_the_button, {
              class: "primary small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.is_add_mode = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить вакансию ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.state.is_failed && !_ctx.error_state.is_cancel)
              ? (_openBlock(), _createBlock(_component_failed_fetch, {
                  key: 0,
                  loading: _ctx.state.is_loading,
                  text: "При получении списка вакансий произошла ошибка",
                  "error-message": _ctx.error_state.message,
                  "error-url": _ctx.error_state.url,
                  "error-status": _ctx.error_state.status,
                  onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadVacancies(_ctx.pagination_state.current_page)))
                }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
              : (_openBlock(), _createBlock(_component_list, {
                  key: 1,
                  loading: _ctx.state.is_loading,
                  items: _ctx.state.vacancies,
                  pagination: "",
                  "pagination-current-page": _ctx.pagination_state.current_page,
                  "pagination-limit": _ctx.pagination_state.limit,
                  "pagination-total-items": _ctx.pagination_state.total_items,
                  "pagination-total-pages": _ctx.pagination_state.total_pages,
                  onChangePage: _ctx.loadVacancies
                }, {
                  item: _withCtx(({ item }) => [
                    _createVNode(_component_vacancy_list_item, { item: item }, null, 8, ["item"])
                  ]),
                  _: 1
                }, 8, ["loading", "items", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"]))
          ])
        ], 64))
  ]))
}